// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-69c4899f] .el-dialog .el-button{margin-bottom:12px}", ""]);
// Exports
module.exports = exports;
